module.exports = __webpack_public_path__ + "img/sm-twitter.51ce1431.svg";